import { render, staticRenderFns } from "./MetricsChartComponent.vue?vue&type=template&id=e7620194"
import script from "./MetricsChartComponent.vue?vue&type=script&lang=js"
export * from "./MetricsChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports